<template>
  <div style="width: 100%">
    <youtube
      ref="youtube"
      :player-vars="playerVars"
      :video-id="srcVideo"
      style="width: 100%; height: 100%; padding: 10px;"
      @playing="playing"
      @ended="ended"/>

  </div>
</template>
<script>
export default {
  props: {
    src: null,
    autoplay: false,
    onFinish:  {
      type: Function,
      default: () => {() => {}}
    }
  },
  data () {
    return {
      videoId: 'lG0Ys-2d4MA',
      playerVars: {
        autoplay: 1,
        rel: 0
      }
    }
  },
  computed: {
    player () {
      return this.$refs.youtube.player
    },
    srcVideo () {
      return this.src === null ? this.videoId : this.src
    }
  },
  mounted () {
    console.log(this.autoplay)
    if (this.autoplay) this.playVideo()
  },
  methods: {
    playVideo () {
      this.player.playVideo()
    },
    playing () {
      console.log('\o/ we are watching!!!')
    },
    ended () {
      this.onFinish()
    }
  }
}
</script>
